import { useState } from "react";

import { ErrorMessage as ErrorMessageType } from "services/firebase/auth/errorTranslator";

import SignInCardChildAddParentByCode from "../../sign-in-form/components/SignInCard/components/flows/SignInCardChildAddParentByCode";
import SignInCardParent from "../../sign-in-form/components/SignInCard/components/flows/SignInCardParent";
import SignInCardStudentJoinClass from "../../sign-in-form/components/SignInCard/components/flows/SignInCardStudentJoinClass";
import SignInCardTeacherClassInvite from "../../sign-in-form/components/SignInCard/components/flows/SignInCardTeacherClassInvite";
import SignInCardCommon, {
  RenderSignInFormProps
} from "../../sign-in-form/components/SignInCard/components/SignInCardCommon";
import { useIsChildAddParentByCodeSignIn } from "../../sign-in-form/hooks/useIsChildAddParentByCodeSignIn";
import { useIsParentSignIn } from "../../sign-in-form/hooks/useIsParentSignIn";
import { useIsStudentJoinClassSignIn } from "../../sign-in-form/hooks/useIsStudentJoinClassSignIn";
import { useIsTeacherClassInviteSignIn } from "../../sign-in-form/hooks/useIsTeacherClassInviteSignIn";

export type AuthFlowsContainerProps<AuthProps> = {
  redirectAuthenticatedUserTo?: string;
  defaultErrorMessage?: ErrorMessageType;
  children: (props: RenderSignInFormProps) => JSX.Element;
} & AuthProps;

type Props<AuthProps> = AuthFlowsContainerProps<AuthProps> & {
  action: "Log in" | "Sign up";
};

export default function AuthFlowsContainer<AuthProps>(props: Props<AuthProps>) {
  const [errorMessage, setErrorMessage] = useState<
    ErrorMessageType | undefined
  >();

  const isParentSignIn = useIsParentSignIn();
  const isChildAddParentByCodeSignIn = useIsChildAddParentByCodeSignIn();
  const isStudentJoinClassSignIn = useIsStudentJoinClassSignIn();
  const isTeacherClassInviteSignIn = useIsTeacherClassInviteSignIn();

  const commonProps = {
    ...props,
    errorMessage: errorMessage ?? props.defaultErrorMessage,
    setErrorMessage: setErrorMessage
  };

  return (
    <>
      {isParentSignIn ? (
        <SignInCardParent {...commonProps} />
      ) : isTeacherClassInviteSignIn ? (
        <SignInCardTeacherClassInvite {...commonProps} />
      ) : isStudentJoinClassSignIn ? (
        <SignInCardStudentJoinClass {...commonProps} />
      ) : isChildAddParentByCodeSignIn ? (
        <SignInCardChildAddParentByCode {...commonProps} />
      ) : (
        <SignInCardCommon {...commonProps} />
      )}
    </>
  );
}
